import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AdminApp } from "./AdminApp";
import { ADMIN_BASE } from "./constants/paths";

export const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path={`${ADMIN_BASE}/*`} element={<AdminApp />} />
      <Route path="/phhelper/digar" element={<Navigate to={`${ADMIN_BASE}/helpers/digar`} replace />} />
      <Route path="/phhelper/more" element={<Navigate to={`${ADMIN_BASE}/helpers/more`} replace />} />
      <Route path="/helpers/digar" element={<Navigate to={`${ADMIN_BASE}/helpers/digar`} replace />} />
      <Route path="/helpers/more" element={<Navigate to={`${ADMIN_BASE}/helpers/more`} replace />} />
      <Route path="*" element={<Navigate to={ADMIN_BASE} replace />} />
    </Routes>
  </BrowserRouter>
);
